import { i18n } from "@/i18n-config";

export const SUPPORT_TOPIC_VALUES = [
  "account_access",
  "payment_subscription",
  "bug_report",
  "course_issue",
  "feature_request",
  "other",
] as const;

export type SupportTopic = (typeof SUPPORT_TOPIC_VALUES)[number];

export function isSupportTopic(value: unknown): value is SupportTopic {
  return typeof value === "string" && (SUPPORT_TOPIC_VALUES as readonly string[]).includes(value);
}

export const SUPPORT_STATUS_VALUES = ["open", "in_progress", "closed"] as const;

export type SupportStatus = (typeof SUPPORT_STATUS_VALUES)[number];

export function isSupportStatus(value: unknown): value is SupportStatus {
  return typeof value === "string" && (SUPPORT_STATUS_VALUES as readonly string[]).includes(value);
}

export const SUPPORT_SCREENSHOT_ALLOWED_MIME_TYPES = ["image/png", "image/jpeg", "image/webp"] as const;

export const SUPPORT_SCREENSHOT_MAX_BYTES = 5 * 1024 * 1024;

export function isAllowedSupportScreenshotMimeType(value: unknown): boolean {
  return typeof value === "string" && (SUPPORT_SCREENSHOT_ALLOWED_MIME_TYPES as readonly string[]).includes(value);
}

export function isSupportedLanguage(value: unknown): value is (typeof i18n.locales)[number] {
  return typeof value === "string" && (i18n.locales as readonly string[]).includes(value);
}
